import {
  AttendanceCompensationsDocument,
  BulkCreateAttendanceTimeBlockCompensationDocument,
  BulkCreateAttendanceTimeBlockCompensationMutation,
  BulkCreateAttendanceTimeBlockCompensationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkCreateAttendanceTimeBlockCompensation = () => {
  const [bulkCreateTimeBlockCompensation, { loading }] = useMutation(
    BulkCreateAttendanceTimeBlockCompensationDocument,
    {
      extractorFn: (data: BulkCreateAttendanceTimeBlockCompensationMutation) =>
        data.attendanceMutations.bulkCreateTimeBlockSupplementAttendanceManualCompensation,
    }
  )

  const create = (variables: BulkCreateAttendanceTimeBlockCompensationMutationVariables) => {
    return bulkCreateTimeBlockCompensation({
      variables,
      refetchQueries: [
        BulkCreateAttendanceTimeBlockCompensationDocument,
        AttendanceCompensationsDocument,
      ],
    })
  }

  return {
    loading,
    create,
  }
}
